var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("input", {
        ref: "hiddenFileInput",
        staticStyle: { display: "none" },
        attrs: { type: "file" },
        on: { change: _vm.uploadFileChange },
      }),
      _c(
        "a-button-group",
        { staticStyle: { width: "100%" } },
        [
          _c(
            "a-button",
            {
              staticStyle: { width: "100%", "text-align": "left" },
              on: { click: _vm.viewOrDownloadFile },
            },
            [
              _c("a", { staticStyle: { "text-decoration": "underline" } }, [
                _vm._v(_vm._s(_vm.localValue.name)),
              ]),
            ]
          ),
          _c("a-button", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.localValue.name && !_vm.disabled,
                expression: "localValue.name&&!disabled",
              },
            ],
            attrs: { disabled: _vm.disabled, type: "danger", icon: "delete" },
            on: { click: _vm.deleteFile },
          }),
          _c(
            "a-button",
            {
              attrs: {
                disabled: _vm.disabled,
                type: "primary",
                icon: "upload",
                loading: _vm.iconLoading,
              },
              on: { click: _vm.choiceImg },
            },
            [_vm._v(" 上传 ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }